var _path, _radialGradient, _path2, _radialGradient2, _path3, _radialGradient3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserEdge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1de9b6",
    d: "M4,23.481C4,15.673,10.557,4,24.014,4C37.452,4,44,13.923,44,20.905c0,5.604-4.429,9.732-9.992,9.732 c-4.245,0-6.759-1.408-6.759-2.53c0-0.726,1.755-1.837,1.755-3.982c0-2.565-1.986-5.137-5.045-5.137 c-2.934,0-4.974,2.442-4.974,4.905c0,5.952,5.63,11.644,13.931,11.644c4.959,0,6.759-1.828,7.403-1.828 c0.196,0,0.647,0.08,0.647,0.603c0,0.5-5.486,9.686-16.94,9.686C12.632,44,4,35.023,4,23.481z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_edge_svg__2pm2zgLwrfHW4PMfqfOjYa",
    cx: 17.993,
    cy: 32.825,
    r: 21.348,
    gradientTransform: "matrix(1 0 0 1.1083 0 -3.529)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#0083de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#006aac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#005a8c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#browser_edge_svg__2pm2zgLwrfHW4PMfqfOjYa)",
    d: "M4,23.481c0-7.808,7.615-12.04,12.73-12.04c13.439,0,17.277,2.483,17.277,9.465 c0,5.604-5.003,5.366-5.003,3.221c0-2.565-1.986-5.137-5.045-5.137c-2.934,0-4.974,2.442-4.974,4.905 c0,5.952,5.63,11.644,13.931,11.644c4.959,0,6.759-1.828,7.403-1.828c0.196,0,0.647,0.08,0.647,0.603c0,0.5-5.486,9.686-16.94,9.686 C12.632,44,4,35.023,4,23.481z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_edge_svg__2pm2zgLwrfHW4PMfqfOjYb",
    cx: 28.082,
    cy: 29.295,
    r: 16.478,
    gradientTransform: "matrix(1 0 0 1.0028 0 -.067)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#05509b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#054e98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033e78"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#browser_edge_svg__2pm2zgLwrfHW4PMfqfOjYb)",
    d: "M18.985,23.894c0-2.298,1.775-4.575,4.395-4.871c-4.104,0.349-8.798,4.375-8.798,11.831 c0,7.963,6.864,13.465,13.943,12.628c8.386-1.927,12.441-8.74,12.441-9.168c0-0.523-0.451-0.603-0.647-0.603 c-0.643,0-2.444,1.828-7.403,1.828C24.615,35.539,18.985,29.847,18.985,23.894z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_edge_svg__2pm2zgLwrfHW4PMfqfOjYc",
    cx: 47.648,
    cy: 16.079,
    r: 61.532,
    gradientTransform: "matrix(-1 0 0 -1.5084 95.296 40.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5eeb69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#4bc958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#4ac862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#47c68b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#44c4ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#41c2cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#3fc1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#3ec0f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#3dbffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#3dbffd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#browser_edge_svg__2pm2zgLwrfHW4PMfqfOjYc)",
    d: "M4,23.481C4,15.673,10.557,4,24.014,4C37.452,4,44,13.923,44,20.905 c0,5.604-4.429,9.732-9.992,9.732c-4.245,0-6.759-1.408-6.759-2.53c0-0.726,1.755-1.837,1.755-3.982 c0-2.565-2.076-10.678-12.628-10.678C13.442,13.448,5.256,14.745,4,23.481z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserEdge);
export default __webpack_public_path__ + "static/media/browser_edge.efc1788293254c7148d273770d117fec.svg";
export { ForwardRef as ReactComponent };